<template>
  <div class="search-box position-relative">
    <form
      class="d-flex"
      @submit.prevent="searchData"
    >
      <input
        v-model="keywords"
        type="text"
        class="search-input"
        placeholder="Search Bangladesh largest online autherntice marketplace"
        @input="fetchSuggestions"
      >
      <button
        class="search-btn"
        type="submit"
      >
        <i class="fas fa-search" />
      </button>
    </form>

    <!-- Suggestions -->
    <div
      v-if="showSuggestions"
      class="suggestion-dropdown"
    >
      <ul v-if="suggestions.length">
        <li
          v-for="(item, index) in suggestions"
          :key="index"
          @click="selectSuggestion(item)"
        >
          <img
            v-if="item.image"
            :src="item.image"
            alt="icon"
          >
          <span>{{ item.name }}</span>
        </li>
      </ul>

      <!-- Trending -->
      <div
        v-else
        class="trending-box"
      >
        <p class="fw-bold mb-1">
          Trending Searches
        </p>
        <ul>
          <li
            v-for="(trend, i) in trending"
            :key="i"
            @click="selectSuggestion({ name: trend })"
          >
            {{ trend }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<!-- <script>
import axios from '@/utils/axiosConfig';

export default {
    name: 'SignUp',
    data() {
        return {
            keywords: ""
        }
    },
    methods: {
        searchData() {
            this.$router.push('/search/?s=' + this.keywords + '')
        },
    },
};
</script> -->

<script>
import axios from '@/utils/axiosConfig';

export default {
    data() {
        return {
            keywords: "",
            suggestions: [],
            trending: [],
            showSuggestions: false,
            typingTimeout: null,
        }
    },
    methods: {
        async fetchSuggestions() {
            clearTimeout(this.typingTimeout);

            if (!this.keywords.trim()) {
                this.suggestions = [];
                this.showSuggestions = false;
                return;
            }

            this.typingTimeout = setTimeout(async () => {
                try {
                    const response = await axios.get(`search-suggestion`, {
                        params: { search_keywords: this.keywords }
                    });

                    if (response.data.success) {
                        this.suggestions = response.data.data.suggestion;
                        this.trending = response.data.data.trending_search;
                        this.showSuggestions = true;
                    }
                } catch (error) {
                    console.error(error);
                }
            }, 300);
        },
        selectSuggestion(item) {
            this.keywords = item.name;
            this.showSuggestions = false;
            this.searchData();
        },
        searchData() {
            this.showSuggestions = false;
            this.$router.push('/search/?s=' + this.keywords);
        }
    }
}
</script>


<style scoped>
/* suggestion box */
.suggestion-dropdown {
    position: absolute;
    top: 105%;
    /* right below input */
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 9999;
    /* overlay header */
    max-height: 350px;
    overflow-y: auto;
    padding: 5px 0;
    overflow: visible;
}

/* list style */
.suggestion-dropdown ul {
    margin: 0;
    padding: 0;
    list-style: none;
}

.suggestion-dropdown li {
    display: flex;
    align-items: center;
    padding: 8px 12px;
    cursor: pointer;
    transition: background 0.2s;
}

.suggestion-dropdown li:hover {
    background: #f8f8f8;
}

.suggestion-dropdown img {
    width: 28px;
    height: 28px;
    object-fit: cover;
    margin-right: 8px;
    border-radius: 4px;
}

/* trending */
.trending-box {
    padding: 10px 12px;
}

.trending-box ul {
    margin: 0;
    padding: 0;
    list-style: none;
}

.trending-box li {
    padding: 6px 0;
    cursor: pointer;
}

.trending-box li:hover {
    text-decoration: underline;
}
</style>
